import { TAB_SECTION } from "./Constants";

export default function tabsReducer(state, action) {
    const { type, payload } = action;
    if (!state) state = ""
    if (type === TAB_SECTION) {
        return {
            tabSection: payload
        }
    }
    return state;
}
